export default __webpack_public_path__ + "static/Logistics-59a07714fb3bb089430b9e8ea5938d65.png";